import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
  },
  title: {
    padding: '1rem 0 1rem 2rem',
    marginLeft: '-1rem',
    width: '100vw',
    fontSize: 28,
    backgroundColor: theme.colors.dark.midnightBlue,
    color: theme.colors.light.freshPowder,
  },
}));
